export enum FileTemplate {
  EXTERNAL_AUDIT = 'externalAudit'
}
